import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionService } from '@services/question.service';
import { RoleManagementService } from '@services/role.management.service';
import { toHTML } from 'ngx-editor';
import { Subscription } from 'rxjs';
import { GlobalToolbarConfig, SurveySingleChoice } from 'src/app/shared/addnewquestion';
import { CkeditorConfig, QuestionSubTypeIdEnum, QuestionTypeIdEnum } from 'src/app/shared/config/questions.config';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { ItemsSubPartEditorComponent } from '../items-sub-part-editor/items-sub-part-editor.component';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import * as Editor from '../../../../assets/ckeditor';
import Adapter from '../ckeditorAdapter';
@Component({
  selector: 'app-items-survey-single-choice',
  templateUrl: './items-survey-single-choice.component.html',
  styleUrls: ['./items-survey-single-choice.component.scss']
})
export class ItemsSurveySingleChoiceComponent implements OnInit {
  reuseProp = {
    questionuuId: 'questionuuId',
    questiondescription: 'questiondescription',
    description: 'description',
    tempOption: 'tempOption',
    options: 'options',
    correctPoints: 'correctPoints',
    itemId: 'itemId',
    penaltyPoints: 'penaltyPoints',
    minScoreIfAttempt: 'minScoreIfAttempt',
    scoringTypeExactMatch: 'scoringTypeExactMatch'
  }

  @Output() postCreated = new EventEmitter();
  itemId: any;
  surveySingleChoiceForm: FormGroup;
  // optionEditor: Editor = new Editor();
  // questionEditor: Editor = new Editor();
  // editor: Editor = new Editor();
  isEditMode: boolean = false;
  isListMode: boolean = false;
  isQuestionAdded: boolean = false;
  validateQuestion: boolean = false;
  showOptions: boolean = false;
  questionId: string;
  optionToDelete: number[] = [];
  listDisplay = false;
  toolbar = GlobalToolbarConfig;
  displayQuestionType: boolean = false;
  private routerSubscription: Subscription;
  ckeditorConfig = CkeditorConfig;
  isCkeditorLoading: boolean = true;
  questionuuuid: any;
  QuestionOrientation: any;
  //-------- CKEditor5 Version---------
  @ViewChild("myEditor") myEditor: any;
  @ViewChild("myEditor1") myEditor1: any;
  public Editor: any = Editor;
  errorMessage;
  errorMessageOption;
  QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;
  QuestionTypeIdEnum = QuestionTypeIdEnum;  public uploadedFileNames = [];
  public uploadedFileOptions = [];

  QuestionImages = []
  optionImages = []
  imageId: number = 1;
  constructor(
    public roleSer: RoleManagementService,
    public sanitizer: DomSanitizer,
    public questionService: QuestionService,
    public itemservice: ItemService,
    private notificationService: NotificationService,
    private routerstate: ActivatedRoute,
    private webErrorService: WebErrorService,
    public dialog: MatDialog,
    private router: Router,
    private translate: TranslateService) {
    this.routerSubscription = this.routerstate?.parent?.params?.subscribe((data) => {
      this.itemId = data.id;
    });

    this.questionId = sessionStorage.getItem(this.reuseProp.questionuuId);
    if (!this.questionId) {
      this.questionId = this.router.getCurrentNavigation()?.extras?.state?.questionId;
    }
    this.surveySingleChoiceForm = new FormGroup({
      ansRenderCount: new FormControl(0),
      questionOrder: new FormControl(0),
      questionSubTypeId: new FormControl(QuestionSubTypeIdEnum.SurveySingleChoice),
      questionTypeId: new FormControl(QuestionTypeIdEnum.SurveySingleChoice),
      questiondisplayoptions: new FormControl('Vertical'),
      active: new FormControl(true),
      autoScoring: new FormControl(false),
      allowCheckAnswer: new FormControl(false),
      shuffleOption: new FormControl(false),
      [this.reuseProp.scoringTypeExactMatch]: new FormControl(false),
      [this.reuseProp.questiondescription]: new FormGroup({ description: new FormControl('', Validators.required), mediaURL: new FormControl([""]), file_name: new FormControl([""]) }),
      [this.reuseProp.itemId]: new FormControl(''),
      [this.reuseProp.options]: new FormArray([], [Validators.required, Validators.minLength(2)]),
      [this.reuseProp.correctPoints]: new FormControl(0),
      [this.reuseProp.penaltyPoints]: new FormControl(0),
      [this.reuseProp.minScoreIfAttempt]: new FormControl(0),
      [this.reuseProp.tempOption]: new FormControl(),
      questionImages: new FormControl(''),
      optionImages: new FormControl('')
    });

    this.questionService.getQuestionOrientation().subscribe(o => {this.QuestionOrientation = o.data})
  }

  get f() {
    return this.surveySingleChoiceForm.controls;
  }

  onReady(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessage = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileNames.push(res.fileName)
        this.QuestionImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  onReadyOption(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    this.uploadedFileOptions = []
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessageOption = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessageOption = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessageOption = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileOptions.push(res.fileName)
        this.optionImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  onClick(event) {
    if (this.errorMessage && event) this.errorMessage = false;
  }

  ngOnInit(): void {
    if (this.questionId) {
      this.isEditMode = true;
      const questionServiceGetSubscription: Subscription = this.questionService
        .getQuestion(this.itemId, this.questionId)
        .subscribe((resdata) => {
          this.questionuuuid = resdata?.data.questionuuId;
          this.isQuestionAdded = true;
          this.showOptions = true;
          this.surveySingleChoiceForm.patchValue(resdata.data);
          this.surveySingleChoiceForm.controls[this.reuseProp.scoringTypeExactMatch].setValue(JSON.stringify(resdata.data.scoringTypeExactMatch));
          if (resdata.data.options && resdata.data.options.length) {
            resdata.data.options.forEach(element => {
              (<FormArray>this.surveySingleChoiceForm.controls[this.reuseProp.options]).push(new FormControl({ ...element, modified: true }));
            })
          };
          this.surveySingleChoiceForm.get(this.reuseProp.options).updateValueAndValidity();
          questionServiceGetSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error);
        });
    }
  }

  saveSurveyQuestion() {
    this.setAndUpdateControl(this.reuseProp.itemId, sessionStorage.getItem(this.reuseProp.itemId));
    if (this.surveySingleChoiceForm.controls[this.reuseProp.options].value.length <= 1) {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg2'), true, 'warn')
      return;
    }

    let question = this.surveySingleChoiceForm.value.questiondescription['description'];
    let question1 = question;//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();

    this.surveySingleChoiceForm.value.questiondescription['file_name'] = this.uploadedFileNames;

    if (question1.length === 0) {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg3'), true, 'warn')
      return;  // Used to display alert message
    }

    this.surveySingleChoiceForm.controls[this.reuseProp.scoringTypeExactMatch].setValue(JSON.parse(this.surveySingleChoiceForm.controls[this.reuseProp.scoringTypeExactMatch].value));

    this.surveySingleChoiceForm.value.options.forEach(element => {
      element.answerDescription['description'] = element.answerDescription['description'];//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '');
    });

    if (this.QuestionImages.length > 0) {
      this.QuestionImages.forEach(ele => {

        question1 = question1.replace(ele.base64, ele.uniqueId)

        let startIndex = ele.base64.lastIndexOf('base64,');
        ele.base64 = ele.base64.substring(startIndex +7)
      })
    }
    this.surveySingleChoiceForm.value.questiondescription['description'] = question1;
    this.surveySingleChoiceForm.value.questionImages = this.QuestionImages;

    if (this.optionImages.length > 0) {
      this.optionImages.forEach(ele => {
        this.surveySingleChoiceForm.value.options.forEach(option => {
          option.answerDescription.description = option.answerDescription.description.replace(ele.base64, ele.uniqueId)
        })
        let startIndex = ele.base64.lastIndexOf('base64,');
        ele.base64 = ele.base64.substring(startIndex +7)
      })
    }

    this.surveySingleChoiceForm.value.optionImages = this.optionImages;


    if (this.isEditMode) {
      const questionServiceUpdateSubscription: Subscription = this.questionService.updateQuestion(this.surveySingleChoiceForm.value, this.itemId, this.questionId).subscribe(
        (resData) => {
          this.optionToDelete.forEach(optId => {
            this.questionService.deleteOption(this.questionId, optId).subscribe(() => { },
            (error) => {
              this.webErrorService.handleAPIErrors(error);
            });
          });
          this.itemservice.editedGetItem(resData.data);
          this.notificationService.success(resData?.message);
          // this.itemservice.questionCountUpdate.next(true);
          // this.questionService.reloadList.next(true);
          this.isListMode = true;
          questionServiceUpdateSubscription.unsubscribe();
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
    } else {
      const questionServicePostSubscription: Subscription = this.questionService.addQuestion(this.surveySingleChoiceForm.value, this.itemId).subscribe(
        (resData) => {
          this.isEditMode = true;
          this.notificationService.success(resData?.message);
          // this.itemservice.questionCountUpdate.next(true);
          // this.questionService.reloadList.next(true);
          this.isEditMode = true;
          this.isListMode = true;
          questionServicePostSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
    }
  }

  validateEditorText(value: string): boolean {
    return value.length != 0;
  }

  setAndUpdateControl(controlName: string, value: any): void {
    this.surveySingleChoiceForm.get(controlName).patchValue(value);
    this.surveySingleChoiceForm.get(controlName).updateValueAndValidity();
  }

  validateAndSetQuestion(): void {
    let question = this.surveySingleChoiceForm.controls[this.reuseProp.questiondescription].value[this.reuseProp.description];
    let question1 = question;//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();

    this.isQuestionAdded = this.validateEditorText(question1);
    this.validateQuestion = this.isQuestionAdded === false;
  }

  validateAndAddOption(): void {
    let questionHtml = this.surveySingleChoiceForm.controls[this.reuseProp.questiondescription].value[this.reuseProp.description];
    if (!questionHtml || questionHtml.length == 0) {
      this.isQuestionAdded = false;
      this.validateQuestion = true;
    } else {
      this.errorMessageOption = false;
      this.isQuestionAdded = true;
      this.validateQuestion = false;
      let newValue = this.surveySingleChoiceForm.controls[this.reuseProp.tempOption].value.replace(/&nbsp;/g,'').trim()
      // .replace(/<img/g, '<img width="100" height="100"');
      let question1 = newValue;//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();

      if (newValue.type) { newValue = toHTML(newValue); }
      if (this.validateEditorText(question1)) {
        this.showOptions = true;
        let existingValue = this.surveySingleChoiceForm.controls[this.reuseProp.options].value;
        let newOpt: SurveySingleChoice = {
          answerDescription: { description: newValue, mediaURL: [''], file_name: this.uploadedFileOptions},
          answerValid: false, correctPoints: 0, modified: false, optionId: 1, selected: false, id: 0, sequencialLimit: 0, isDropDownFormat: false,
          arrangeOrder: 0
        };
        if (existingValue && existingValue.length) {
          newOpt = { ...newOpt, optionId: existingValue[existingValue.length - 1].optionId + 1 };
        }
        (<FormArray>this.surveySingleChoiceForm.controls[this.reuseProp.options]).push(new FormControl(newOpt));
        this.surveySingleChoiceForm.value[this.reuseProp.options].forEach((element, index) => {
          element.arrangeOrder = index + 1;
        });
        this.setAndUpdateControl(this.reuseProp.tempOption, '');
        this.uploadedFileOptions = []

        // this.optionEditor.setContent('');
      }
    }
  }

  onCheckRadioOption(value) {
    if (value) {
      this.surveySingleChoiceForm.controls[this.reuseProp.options].value.forEach((element) => {
        if (element.optionId == value.optionId
        ) {
          element.answerValid = true;
        } else {
          element.answerValid = false;
        }
      })
    }
  }

  removeArrayItem(index: number, property: string): void {
    const dialogRef = this.dialog.open(DelMessageComponent, {
      data: {
        message: this.translate.instant('questions.typeOfQuestions.surveySingleChoice.deletePopup.message') + property.slice(0, -1) + '?',
        buttonText: {
          ok: this.translate.instant('questions.typeOfQuestions.surveySingleChoice.deletePopup.btnYes'),
          cancel: this.translate.instant('questions.typeOfQuestions.surveySingleChoice.deletePopup.btnNo'),
        },
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        if ((<FormArray>this.surveySingleChoiceForm.get(property)).length == 2) {
          this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg2'), true, 'warn')
          return;
        }
        this.optionToDelete.push((<FormArray>this.surveySingleChoiceForm.get(property)).at(index).value.id);
        (<FormArray>this.surveySingleChoiceForm.get(property)).removeAt(index);
        this.surveySingleChoiceForm.get(property).updateValueAndValidity();
      }
    })
  }

  back() {
    this.postCreated.emit('false');
    this.displayQuestionType = true;
    // this.editor.destroy();
  }

  openDialog(value: any): void {
    console.log(value?.answerDescription?.description, 'option description')
    const dialogSubscription = this.dialog.open(ItemsSubPartEditorComponent,
      { width: '950px', height: '350px', panelClass: 'option-dialog', data: { value: value?.answerDescription?.description } })
      .afterClosed().subscribe((result) => {
        if (result) {
          this.itemservice.getfileName.subscribe(file=>{
            (<FormArray>this.surveySingleChoiceForm.controls[this.reuseProp.options])
            .at(this.surveySingleChoiceForm.controls[this.reuseProp.options].value.findIndex((d: any) => d.optionId == value.optionId))
            .setValue({ ...value, answerDescription: { description: result, mediaURL: [''], file_name: file} });
          this.surveySingleChoiceForm.get(this.reuseProp.options).updateValueAndValidity();
          });
        }
        dialogSubscription.unsubscribe();
      });
  }

  onCkeditorReady() {
    this.isCkeditorLoading = false;
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  dragAndDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.surveySingleChoiceForm.controls[this.reuseProp.options].value, event.previousIndex, event.currentIndex);
    this.saveOderApiCall();
  }

  saveOderApiCall() {
    let payload = [];
    this.surveySingleChoiceForm.controls[this.reuseProp.options].value.forEach((e, index) => {
      let que = {
        "optionid": e.optionId,
        "arrangeorder": index + 1
      };
      e.arrangeOrder = index + 1;
      payload.push(que);
    });

    this.itemservice.arrangeOrderForOptions(this.questionuuuid, payload).subscribe((data) => {
    },
    (error) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }
}

export class OptionUpdateText {
  oldValue: any;
  newValue: any;
  optionIdDia: any;
}
